module.exports = new __parcel__URL__("changes.2587d023.svg").toString();